import { api } from '@/lib/api';

import type { LoginRequest, LoginResponse, User } from '../types';

export const authApi = {
  /**
   * Login with phone and password
   */
  login: (data: LoginRequest) => api.post<LoginResponse>('/auth/login', data),

  /**
   * Logout current user
   */
  logout: () => api.post<void>('/auth/logout'),

  /**
   * Get current user profile
   */
  getProfile: () => api.get<User>('/users/profile'),

  /**
   * Refresh access token (handled by axios interceptor, but exposed for manual use)
   */
  refreshToken: (refreshToken: string) =>
    api.put<{ access: string }>('/auth/renew-access', { refresh: refreshToken }),
};
